import React, { useEffect, useState } from "react";
import "./InfoBox.css";
import { useView } from "src/contexts/ViewContext";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { calculateHeight, fromMmToUnit } from "src/helpers/dimensions";

const InfoBox: React.FC = () => {
  const [afterButtonText, setAfterButtonText] = useState("");

  useEffect(() => {
    const afterUiButtonsText = document.getElementById("configurator-text");

    if (afterUiButtonsText) {
      setAfterButtonText(afterUiButtonsText.innerHTML);
    }
  }, []);

  return (
    // <div
    //   className={"configurator-text"}
    //   dangerouslySetInnerHTML={{ __html: afterButtonText }}
    // ></div>
    <></>
  );
};

export default InfoBox;
